import { injectable } from 'inversify';

import { t } from '@vk-hr-tek/core/translations';
import { ChipColorUnion } from '@vk-hr-tek/ui/ColoredChip';
import { FormatService } from '@vk-hr-tek/core/format';

import {
  AdminVacationSchedulesListItem,
  VacationSchedule,
} from '@app/gen/vacations';

import { VacationsMapper } from './vacations.mapper';

type StatusType = 'new' | 'active' | 'completed' | 'canceled' | 'starting';

@injectable()
export class VacationsListMapper {
  constructor(
    private readonly format: FormatService,
    private readonly vacations: VacationsMapper,
  ) {}

  private processSheduleStatus(status: StatusType): {
    statusName: string;
    statusChipColor: ChipColorUnion;
  } {
    switch (status) {
      case 'active':
        return { statusName: 'Активно', statusChipColor: 'green' };

      case 'completed':
        return {
          statusName: 'Завершено',
          statusChipColor: 'gray',
        };

      case 'new':
        return {
          statusName: 'Создано',
          statusChipColor: 'blue',
        };

      case 'canceled':
        return { statusName: 'Отменено', statusChipColor: 'red' };

      case 'starting':
        return {
          statusName: t(
            'settings.mappers.vacationsList.tasksCreationForEmployeeText',
          ),
          statusChipColor: 'gray',
        };
    }
  }

  processVacationsCompaniesList(companies: AdminVacationSchedulesListItem[]) {
    return companies.map(
      ({
        company_id,
        company_name,
        has_schedule_for_next_year,
        vacation_schedules,
      }) => ({
        id: company_id,
        name: company_name,
        hasCompanySchedule: has_schedule_for_next_year,
        schedules: this.processVacationsSchedules(vacation_schedules),
      }),
    );
  }

  private processVacationsSchedules(schedules: VacationSchedule[]) {
    return schedules.map(
      ({
        active_to,
        id,
        status,
        year,
        event_stats,
        units,
        available_adding_employees,
        employee_deadline,
        type,
        custom_type,
      }) => ({
        id,
        year,
        activeTo: this.format.toDate(active_to),
        status,
        eventsStats: event_stats,
        units,
        availableAddingEmployees:
          this.vacations.processAvailableAddingEmployees(
            available_adding_employees,
            employee_deadline,
          ),
        ...this.processSheduleStatus(status),
        type,
        customType: custom_type,
      }),
    );
  }
}
